import React from 'react';
import MainLayout from "../app/components/Layouts/MainLayout";

class Privacy extends React.Component {

    render() {
        return (
            <MainLayout>
                <div className="container">
                    {/*<Helmet>*/}
                    {/*    <title>Privacy Policy</title>*/}
                    {/*</Helmet>*/}
                    <div className="row">
                        <div className="col-12" id="terms">
                            <div className='p-2'>
                                <h5 className="text-center m-0 mt-1">PRIVACY POLICY</h5>
                                <div className="text-right mb-1">
                                    <span><b><i>Effective as of February 22, 2022</i></b></span>
                                </div>
                                <p>
                                    <h6>1. INTRODUCTION</h6>
                                    <p>We collect, use, process and share personal data in accordance with privacy laws
                                        to make sure your data protection rights are implemented and enforceable. We
                                        integrate various technical and organizational solutions to comply with
                                        applicable legislation related to personal data, privacy, and security
                                        protection in countries where we operate or where the applicable law applies to
                                        us. This Privacy Policy sets forth the basic rules and principles by which we
                                        process your personal data, and mentions our responsibilities while processing
                                        your personal data.</p>
                                    <div><b>Our contact information: <br/> <i>Rolik Data Directs</i> <br/> <i>Registration
                                        number: 516153194</i>
                                        <br/> <i>Registered address: 5 Kordova St, Tel Aviv, Israel</i> <br/>
                                        <i>Email: <a
                                            href="mailto:info@smarterflyer.com">info@smarterflyer.com</a>
                                        </i></b></div>

                                </p>
                                <p>
                                    <h6>2. TERMS WE USE AS LEGAL GUIDELINES OF THE PROCESSING</h6>
                                    <p>There are some legal bases for the processing of your personal data and we count
                                        on them to process your personal data. We use the main three bases to process
                                        your personal data: consent, and legitimate interest.</p>
                                    <p>Consent - your clear agreement to the processing of your personal data for a
                                        specific purpose.</p>
                                    <p>Legitimate Interests - the reason why the processing your data is necessary which
                                        is based on the legitimate interests or the legitimate interests of a third
                                        party, provided those interests are not outweighed by your rights and interests
                                        and those interests have a specific purpose, they are necessary, and they are
                                        balanced).</p>
                                    <p>Some applicable laws may indicate other legal grounds for the processing and when
                                        applicable we will count on such grounds.</p>
                                </p>
                                <p>
                                    <h6>3. CONSENT RULE AND INTERRELATION WITH OTHER LEGAL GROUNDS</h6>
                                    <p>If you have given consent to the processing of your data you can freely withdraw
                                        such consent at any time by contacting us.</p>
                                    <p>If you do withdraw your consent, and if we do not have another legal basis for
                                        the processing of your data, then we will stop the processing of the personal
                                        data and may delete in specific situations, including in case if you request the
                                        deletion of your personal data and we are obliged to delete.</p>
                                    <p>If we have another legal basis for the processing of your data, then we may
                                        continue to do so, subject to your legal interests and rights.</p>
                                </p>
                                <p>
                                    <h6>4. OUR RESPONSIBILITIES</h6>
                                    <p>When we process personal data, we have obligations according to the applicable
                                        laws. We act as a data controller when we determine the purposes and means of
                                        the processing of your personal data. As a data processor, we process personal
                                        data on behalf of the controller.</p>

                                </p>
                                <p>
                                    <h6>5. RECOMMENDATIONS FOR YOU</h6>
                                    <p>You should read this Privacy Policy carefully. We want to make sure that you
                                        understand all your rights. It is important for both of us that you maintain
                                        your personal data confidential and secure.</p>
                                    <p>If you provide us with personal data about other individuals, we will only employ
                                        that data for the special reason for which it was provided to us. By sending the
                                        data, you shall be sure that you have the right to dispose to process the
                                        personal data on your behalf in accordance with this Privacy Policy. In case if
                                        you submit a third party’s personal data, be sure that you have a legal basis
                                        for the processing of such data.</p>
                                    <p>According to the applicable law, you may become a data controller/processor and
                                        it will impose on you additional obligations.</p>

                                </p>
                                <p>
                                    <h6>6. PROCESSED DATA</h6>
                                    <p>We process personal data when you interact with our website <a
                                        href="http://smarterflyer.com/">http://smarterflyer.com/</a> (the
                                        “<b>Platform</b>”), especially:</p>
                                    <ul className='dash-list-type'>
                                        <li>you browse any page of the Platform;</li>
                                        <li>you subscribe to our newsletters/updates;</li>
                                        <li>you communicate with us;</li>
                                        <li>you use our services;</li>
                                        <li>you receive notification from us;</li>
                                        <li>we measure Platform’s traffic;</li>
                                        <li>in cases which do not depend on you but we have a legal basis to collect
                                            such data.
                                        </li>

                                    </ul>
                                    <p>
                                        We collect the following types of data:
                                    </p>
                                    <ul className='dash-list-type'>
                                        <li>online browsing history;</li>
                                        <li>demographic details;</li>
                                        <li>email;</li>
                                        <li>data that identifies you such as your IP address, login information, browser
                                            type, and version, time zone setting, browser plug-in types, some location
                                            information about where you might be, operating system and version;
                                        </li>
                                        <li>data on how you use the Platform such as your URL clickstreams (the path you
                                            take through the Platform), page response times, download errors, how long
                                            you stay on web pages, what you do on those pages, how often, and other
                                            actions;
                                        </li>
                                        <li>other personal data you share with us or personal data which we may legally
                                            obtain for our legitimate interests.
                                        </li>
                                    </ul>
                                    <p>
                                        The recipients of the collected data are the highest management level of our
                                        company.
                                    </p>
                                </p>
                                <p>
                                    <h6>7. PURPOSES AND LEGAL BASIS FOR THE PROCESSING</h6>
                                    <p>
                                        We process the data for:
                                        <ul className="dash-list-type">
                                            <li>Providing services. We need to provide services accessible via the
                                                Platform. Legal basis: Consent; Legitimate Interests.
                                            </li>
                                            <li>Providing newsletters/offers which may be interesting to you. Legal
                                                basis: Consent; Legitimate Interests.
                                            </li>
                                            <li>Keeping the Platform running (managing your requests, remembering your
                                                settings, hosting and back-end infrastructure). Legal basis: legitimate
                                                Interests.
                                            </li>
                                            <li>Preventing frauds, illegal activity or any violation of the terms or
                                                Privacy Policy. We may disable access to the Platform, erase or correct
                                                personal data in some cases. Legal basis: legitimate Interests.
                                            </li>
                                            <li>Improving the Platform (testing features, interacting with feedback
                                                platforms, managing landing pages, heat mapping the Platform, traffic
                                                optimization, and data analysis and research, including profiling and
                                                the use of machine learning and other techniques over your data and in
                                                some cases using third parties to do this). Legal basis: legitimate
                                                Interests.
                                            </li>
                                            <li>Customer support (notifying you of any changes to the Platform,
                                                services, solving issues, any bug fixing). Legal basis: Contract;
                                                Legitimate Interests.
                                            </li>

                                        </ul>

                                    </p>

                                </p>
                                <p>
                                    <h6>8. YOUR RIGHTS AS DATA SUBJECT</h6>
                                    <p>You may ask us to refrain from using your data for marketing (when you opted-in).
                                        You can opt-out from marketing by contacting via the contact form.</p>
                                    <p>You can exercise the following rights by sending us by contacting via the contact
                                        form.</p>
                                    <p>You have the right to access information about you, especially:</p>
                                    <ul className="dash-list-type">
                                        <li>the categories of data;</li>
                                        <li>the purposes of data processing;</li>
                                        <li>third parties to whom the data disclosed;</li>
                                        <li>how long the data will be retained and the criteria used to determine that
                                            period;
                                        </li>
                                        <li>other rights regarding the use of your data.</li>

                                    </ul>
                                    <p>You have the right to make us correct any inaccurate personal data about you.</p>
                                    <p>You can object to using your personal data for profiling you or making automated
                                        decisions about you. We may use your data to determine whether we should let you
                                        know information that might be relevant to you (for example, tailoring emails to
                                        you based on your behavior).</p>
                                    <p>You have the right to the data portability of your data to another service or
                                        website. We will give you a copy of your data in a readable format so that you
                                        can provide it to another service. If you ask us and it is technically possible,
                                        we will directly transfer the data to the other service for you.</p>
                                    <p>You have the right to be “forgotten”. You may ask erasing any personal data about
                                        you if it is no longer necessary for us to store the data for purposes of your
                                        use of the Platform.</p>
                                    <p>You have the right to lodge a complaint regarding the use of your data by us. You
                                        can address a complaint to your national regulator.</p>
                                    <p>In the context of the right to access information, we shall provide you with the
                                        information within one month of your request unless there is a justified
                                        requirement to provide such information faster. This term may be extended
                                        according to the applicable law.</p>
                                </p>
                                <p>
                                    <h6>9. SECURITY</h6>
                                    <p>We have security and organizational measures and procedures to secure the data
                                        collected and stored. You acknowledge that no data transmission is guaranteed to
                                        be 100% secure and there may be risks. You are responsible for your login
                                        information and password. You shall keep them confidential. In case if your
                                        privacy has been breached, please contact us immediately.</p>
                                </p>
                                <p>
                                    <h6>10. LOCATION OF THE PROCESSING OF PERSONAL DATA AND THIRD-PARTY SERVICE
                                        PROVIDERS</h6>
                                    <p>The personal data is collected by our company incorporated in Israel.</p>
                                    <p>Our servers are provided by hosting provider. We store your personal data on
                                        Google Cloud, based out of the United States of America which participates in
                                        and has certified their compliance with the EU-U.S. Privacy Shield Framework and
                                        the Swiss-U.S. Privacy Shield Framework. To learn more about the Privacy Shield
                                        Framework, visit the U.S. Department of Commerce’s Privacy Shield List.</p>
                                    <p>The Platform contains links to third-party sites. The Privacy Policy does not
                                        cover the privacy practices of such third parties. These third parties have
                                        their own privacy policies and we do not accept any responsibility or liability
                                        for their sites, features or policies. Please read their privacy policies before
                                        you submit any data to them.</p>
                                    <p>There are the following third parties:</p>
                                    <ul className="dash-list-type">
                                        <li>flight, car rental, hotel websites which show you results according to your
                                            requests;
                                        </li>
                                        <li>Google Analytics and hotjar to analyze data and improve our services and
                                            Platform;
                                        </li>
                                        <li>Google AdSense, Google AdWords, Google Remarketing, Bing, Gemini, Facebook,
                                            Twitter for marketing purposes; and
                                        </li>
                                        <li>Payment processors that are used by our third parties to which you are
                                            redirected.
                                        </li>

                                    </ul>
                                </p>
                                <p>
                                    <h6>11. RETENTION POLICY</h6>
                                    <p>We store personal data as long as we need it and the retention practice depends
                                        on the type of data we collect, regulatory burden, and how we use the personal
                                        data. The retention period is based on criteria that include legally mandated
                                        retention periods, pending or potential litigation, intellectual property or
                                        ownership rights, contract requirements, operational directives or needs, and
                                        historical archiving.</p>
                                    <p>Our usual retention period is 18 months.</p>
                                </p>
                                <p>
                                    <h6>12. COOKIE POLICY</h6>
                                    <p>We collect certain types of information when you access or use the Platform,
                                        including cookies and similar tracking technologies.</p>
                                    <p>Cookies are small data files that are placed on your computer or mobile device
                                        when you visit the Platform. Cookies are used by the Platform in order to make
                                        the Platform work, or to work more efficiently, as well as to provide reporting
                                        information.</p>
                                    <p>You may turn off cookies in your browser via settings. You can block cookies on
                                        your browser to refuse cookies. You may delete cookies. If you turn off cookies,
                                        you can continue to use the Platform and browse its pages, but the Platform and
                                        certain services will not work properly.</p>
                                    <p>We collect essential cookies, functionality cookies, analytics and performance
                                        cookies.</p>

                                </p>
                                <p>
                                    <h6>13. TRANSFER OF YOUR PERSONAL DATA</h6>
                                    <p>In case if you reside in the EU/EEA and we offer our services or goods in your
                                        country, we would like to inform you that information we collect from you will
                                        be processed in Israel which has got a finding of “adequacy” from the European
                                        Union under Article 45 of the GDPR (<a
                                            href="https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A32011D0061">https://eur-lex.europa.eu/legal-content/EN/TXT/?uri=CELEX%3A32011D0061</a>).
                                        The finding allows us to transfer the information from the EU/EEA to Israel
                                        without any derogations.
                                    </p>
                                    <p>We store your personal data on Google Cloud, based out of the United States of
                                        America which participates in and has certified their compliance with the
                                        EU-U.S. Privacy Shield Framework and the Swiss-U.S. Privacy Shield Framework. To
                                        learn more about the Privacy Shield Framework, visit the U.S. Department of
                                        Commerce’s Privacy Shield List.</p>
                                    <p>We still aim to apply appropriate safeguards to protect your privacy, security,
                                        your personal data and to use your personal data only consistent with your
                                        relationship with our company and the practices described in this Privacy
                                        Policy. We also enter into data processing agreements and model clauses with our
                                        vendors when applicable.</p>

                                </p>
                                <p>
                                    <h6>14. CONTACT INFORMATION</h6>
                                    <p>If you still have any question or need a clarification with regard to our privacy
                                        practice, please contact us:</p>
                                    <p>We welcome your comments or questions about the Terms, Privacy Policy, Services,
                                        Website. You may contact us at:</p>
                                    <div><b>Rolik Data Directs</b></div>
                                    <div><b><i>Registered address: 5 Kordova St, Tel Aviv, Israel</i></b></div>
                                    <div><b><i>Email: <a
                                        href="mailto:info@smarterflyer.com">info@smarterflyer.com</a> </i></b>
                                    </div>
                                </p>


                            </div>
                        </div>
                    </div>

                </div>
            </MainLayout>
        );
    }

}

export default Privacy;